/**
 * This module is used to control feature toggles on platforms.
 * Adding a feature flag here will allow you to control the feature toggle
 * via the Admin Portal on the Platform's Configuration form.
 * From the Marketplace, you can then use `useFeatureFlags` composable
 * to control a feature for a specific platform.
 */

export type PlatformFeatureToggles = Partial<
  Record<keyof typeof featuresWithToggles, boolean>
>;

export type FeatureToggleOptions = {
  default: boolean;
  description?: string;
};

export const featuresWithToggles = {
  categoryEventFilters: {
    default: false,
    description: "Determines whether the category filters are displayed on the category page, allowing users to filter events"
  },
  customerPreferences: {
    default: false,
    description: "Determines the availability of customer preference settings. Enabling this flag would provide users with the ability to follow categories, events, and products"
  },
  platformSearch: {
    default: true,
    description: "Determines the availability of the platform-wide search functionality. When active, users can utilize the search feature to find events, products, or categories"
  },
  headerAuthentication: {
    default: true,
    description: "Determines the presence of authentication-related elements in the header section of the platform"
  },
  headerCurrencySwitcher: {
    default: true,
    description: "Determines the presence of the currency switcher in the header section of the platform"
  },
  headerLanguageSwitcher: {
    default: true,
    description: "Determines the presence of the language switcher in the header section of the platform"
  },
  cookieConsent: {
    default: false,
    description: "Determines the visibility of the new cookies banner"
  },
  singleSignOn: {
    default: false,
    description: "Determines the visibility of the single sign-on (SSO) feature"
  },
  amplifyAuth: {
    default: false,
    description: "Toggles if we use Amplify for authentication"
  },
  loginPopup: {
    default: false,
    description: "Determines the visibility of the login popup"
  },
  turnstile: {
    default: false,
    description: "Determines if the Turnstile CAPTCHA is enabled"
  },
  teamContentId: {
    default: false,
    description: "Determines if the team ID is send as content ID for facebook pixel"
  },
  nitroStoryblokEndpoint: {
    default: false,
    description: "Determines if the Nitro Storyblok endpoint is used for fetching content instead of directly going to Storyblok"
  },
  
} as const;